import '../../files/FileUploader.scss';
import * as React from 'react';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { Dialog } from '@shared/ui-react/Dialog';
import { EmailUsers } from '@pages/files/uploader/EmailUsers';
import { Button } from '@shared/ui-react/Button';
import { observer } from 'mobx-react';
import { makeObservable, observable } from 'mobx';
import { Ajax } from '@shared/Ajax';
import { Notify } from '@shared/ui-native/Notify';


export const EmailPageStateDialog = {
    open: (pageStateUrl: string, pageState: IPageState) => {
        const targetEl = document.getElementById('react-portal-root');
        ReactUtils.safeRender(<Dialog onClose={EmailPageStateDialog.close} title={__('js_files.email.send_email')}>
            <EmailPageStateComponent pageStateUrl={pageStateUrl} pageState={pageState}/>
        </Dialog>, targetEl);
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    },
};


@observer
class EmailPageStateComponent extends React.Component<{
    pageStateUrl: string,
    pageState: IPageState
}> {
    private users: EmailUsers;

    @observable checkedUsersCount = 0;
    @observable isSending = false;
    @observable comment = '';

    constructor(
        props: {
            pageStateUrl: string,
            pageState: IPageState
        }
    ) {
        super(props);
        makeObservable(this);
    }

    render() {
        return (
            <div className='padded flex-column' style={{ width: '600px' }}>

                <h5>{__('js_files.email.email_details')}:</h5>
                <div><b>{__('js_files.email.select_users')}:</b></div>
                <EmailUsers ref={el => this.users = el} onChange={this.onUsersChange} defaultScrollHeight='185px'/>
                <div className='margin-top-half'><b>{__('general.comment')}:</b></div>
                <textarea placeholder={`${__('general.add_comment')}...`}
                          defaultValue={this.comment}
                          onChange={e => this.comment = e.currentTarget.value}
                          rows={4}/>
                <hr/>
                <h5 style={{ marginTop: 0 }}>{__('general.saved_view_details')}:</h5>
                <div><b>{__('js_project.project_name')}:</b> {kuura.getProjectName()}</div>
                {this.props.pageState.name &&
                    <div>
                        <b>{__('general.saved_view_name')}:</b> {this.props.pageState.name}
                    </div>}
                <div className='flex-row margin-top-half'>
                    <img style={{ width: '150px' }} src={this.props.pageState.thumbnail} alt="Image"/>
                    {this.props.pageState.description &&
                        <div style={{ marginLeft: '1em', paddingLeft: '1em', borderLeft: '1px solid #C2C2C2' }}>
                            <b>{__('general.saved_view_description')}:</b>
                            <div>{this.props.pageState.description}</div>
                        </div>}
                </div>

                <footer style={{ marginTop: '1em', flexShrink: 0 }}>
                    <Button className='ik-button-primary block ik-button-large' onClick={this.onSend} loading={this.isSending} disabled={!this.checkedUsersCount}>
                        {__('js_files.email.send_email')}
                    </Button>
                </footer>
            </div>
        );
    }

    onUsersChange = () => {
        this.checkedUsersCount = this.users?.getCheckedIds().length ?? 0;
    }

    onSend = () => {
        this.isSending = true;

        const emailUserIds = this.users.getCheckedIds();
        Ajax({
            url: '/api/saved-view/share-by-email',
            method: 'post',
            processData: false,
            data: {
                url: this.props.pageStateUrl,
                uuid: this.props.pageState.uuid,
                sendToUsers: emailUserIds,
                thumbnail: this.props.pageState.thumbnail,
                comment: this.comment
            },
        }).done(
            () => {
                this.users.deselectAll();
                Notify.success(__('js_files.email.send_success'));
            }
        ).fail(() => {
            Notify.error(__('js_files.email.send_error'));
        }).always(() => {
            this.isSending = false;
        });
    }
}
